/**
 * Buddy's entry for one trainer (the navigation's mark, a client's „Plan z Buddym", the module):
 * drawn from what this device remembers until the status read answers, then from the answer, which
 * is remembered for the next visit (`model/buddyEntry.ts` has the rule and why).
 *
 * Mounted with the shell, so the standing is read and remembered before any entry is drawn.
 */

import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';

import { preferenceStore } from '~/shared/lib/preferenceStore';

import { buddyEntry, rememberBuddyEntry, rememberedBuddyEntry, type BuddyEntry } from '../model/buddyEntry';

import { aiStatusQueryOptions } from './aiConversationApi';

export function useBuddyEntry(userId: string | null): BuddyEntry {
  const status = useQuery(aiStatusQueryOptions()).data;
  const entry = buddyEntry(status, userId === null ? null : rememberedBuddyEntry(preferenceStore(), userId));
  const answered = status !== undefined;
  useEffect(() => {
    if (answered && userId !== null) rememberBuddyEntry(preferenceStore(), userId, entry);
  }, [answered, userId, entry]);
  return entry;
}
